import 'core-js/stable';
import 'regenerator-runtime/runtime';
import $ from 'jquery';
global.$ = global.jQuery = $;
export default $;

import 'jquery-ujs';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap";
import '../utils/chrome_fixes.js';
import '@fortawesome/fontawesome-pro/css/all.min.css';

import "react-toggle/style.css";
import './../styles/stylesheets/application.scss';

import React from "react";
import { Provider } from 'react-redux';
import { createRoot } from 'react-dom/client';

import InfluencerApp from "../influencer/InfluencerApp";
import { BrowserRouter as Router } from "react-router-dom";
import store from '../store';
import '../../javascript/utils/heap';
import axios from '../utils/axiosConfig';
import userSession from '../utils/userSession';

const id = userSession('id');

document.addEventListener("DOMContentLoaded", () => {

  const container = document.body.appendChild(document.createElement("div"));

  const root = createRoot(container);
  root.render(<Provider store={store}>
    <Router basename='/influencers'>
      <InfluencerApp />
    </Router>
  </Provider>);
});
